import { render } from "./expertBookingSlider.vue?vue&type=template&id=4f9f5d60&scoped=true&ts=true"
import script from "./expertBookingSlider.vue?vue&type=script&lang=ts"
export * from "./expertBookingSlider.vue?vue&type=script&lang=ts"

import "./expertBookingSlider.vue?vue&type=style&index=0&id=4f9f5d60&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f9f5d60"]])

export default __exports__